module.exports = __webpack_public_path__ + "img/room.57be6a95.svg";